__turbopack_context__.v({
  "cartAction": "QuickAddChip-module-scss-module__oYWSAq__cartAction",
  "chip": "QuickAddChip-module-scss-module__oYWSAq__chip",
  "thumbnail": "QuickAddChip-module-scss-module__oYWSAq__thumbnail",
  "thumbnailImage": "QuickAddChip-module-scss-module__oYWSAq__thumbnailImage",
});
